import { FC } from 'react';
import { CountryAvailabilityState } from '@state/feature/availability-country/AvailabilityCountrySlice';
import CountryAvailability from '../country-availability/CountryAvailability';
import { WithAlert } from '@components/design';
import { feedback } from '@ecosystem/newron-design-system';

interface CountryAvailabilityComponentProps
  extends Pick<CountryAvailabilityState, 'subscribedCountries' | 'unavailableCountriesByPeriodAndPg'> {}

const CountryAvailabilityComponent: FC<CountryAvailabilityComponentProps> = ({
  unavailableCountriesByPeriodAndPg,
  subscribedCountries,
}) => {
  const { ActionType } = feedback;
  const totalAvailableCountries = subscribedCountries.length - unavailableCountriesByPeriodAndPg.length;
  const isCountriesAllAvailable = totalAvailableCountries === subscribedCountries.length;
  if (isCountriesAllAvailable) {
    return null;
  }

  const text = `${totalAvailableCountries.toString()} out of ${subscribedCountries.length.toString()}
     ${
       subscribedCountries.length > 1 ? ' countries are ' : ' country is '
     }loaded for selected time frame. Try an earlier time frame to see data for ${
    subscribedCountries.length > 1 ? ' all these countries' : ' this country'
  }.`;

  return (
    <div className="my-4 bg-white">
      <span data-testid="country-availability-warning-banner">
        <WithAlert title={<CountryAvailability text={text} />} actionType={ActionType.DEFAULT} />
      </span>
    </div>
  );
};

export default CountryAvailabilityComponent;
